import { styles, indexerItemVariants, IndexerTheme } from '../IndexerStyles.css';
import { baseTheme } from './IndexerBaseTheme.css';
import { multiVariantStyles } from './IndexerVariants.css';

/*******************
 * Component Theme
 *******************/

const IndexerStableTheme: IndexerTheme = {
  baseTheme,
  multiVariantStyles,
  variants: indexerItemVariants,
  styles
};

/*******************
 * Exports
 *******************/

export { IndexerStableTheme };
